import styled, { keyframes } from 'styled-components';

export const DocDownloadListsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 24px;

  & [data-testid='accordion-panel'][aria-expanded='false'] {
    padding-bottom: 24px;
  }

  & [data-testid='accordion-panel'][aria-expanded='true'] {
    padding-bottom: 8px;
  }
`;

export const DownloadListItem = styled.button`
  background: var(--cvna-color-grey-1);
  border-radius: 4px;
  border-color: transparent;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 16px;
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  cursor: pointer;
  color: var(--cvna-color-blue-6);
  width: 100%;
  text-align: left;
  align-items: center;

  height: 52px;
  margin-top: 16px;

  &:first-child {
    margin-top: 0;
  }

  &:hover {
    text-decoration: none;
  }

  display: flex;
  justify-content: space-between;

  &:focus {
    border-color: transparent;
    outline-color: transparent;
  }
`;

export const DownloadItemTitle = styled.div`
  // For mobile - devices less than 375px
  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    max-width: 165px;
    word-break: break-all;
  }
`;

export const DownloadListWrapper = styled.div`
  width: 100%;
  padding-top: 16px;
`;

export const DownloadSpinnerAnimation = keyframes`
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0deg);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(360deg);
  }
`;

export const DownloadSpinner = styled.div`
  height: 16px;
  width: 16px;
  position: relative;
  padding: 10px;

  &::before {
    animation: 1.5s linear infinite ${DownloadSpinnerAnimation};
    animation-play-state: inherit;
    border: solid 2px #cfd0d1;
    border-bottom-color: #1c87c9;
    border-radius: 50%;
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    transform: translate3d(-50%, -50%, 0);
    will-change: transform;
  }
`;

export const DocDownloadListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DocDownloadRow = styled.div`
  display: flex;
  cursor: pointer;
`;

export const HeaderButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: none;
  outline: none;
  border-color: none;
  background: #ffffff;
  margin-left: 0;
  margin-right: 34px;
  padding: 0;
  width: 100%;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
  text-align: left;

  &:focus {
    outline: none;
    outline: 0px auto -webkit-focus-ring-color;
  }

  &:hover {
    border: none;
    outline: none;
    border-color: none;
    background: #ffffff;
    box-shadow: 0 0 0 0px white, 0 0 0 0px #ffffff;
  }
`;

export const HR = styled.hr`
  margin: 24px 0 16px;
  border: 1px solid #d9dde9;
`;

export const SubText = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #6d7184;
  margin: 0;
`;

export const ChevronIconWrapper = styled.span<{ isOpen: any }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  & svg {
    transition: transform 0.5s;
    transform: ${(props) =>
      props.isOpen === true ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
`;
